import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqDataToCreate } from "../types";

export const changeFaqGroup = async (
  faqGroupId: string,
  faqData: FaqDataToCreate,
): Promise<void> => {
  const collectionRef = collection(db, `faqGroups/${faqGroupId}/faqs`);
  await addDoc(collectionRef, {
    ...faqData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
};
